"use client";

import type * as React from "react";

import { Box } from "../../components/ui/box.tsx";

/**
 * A row's leading picture: a 32×22 framed thumbnail on the option-row rung,
 * where an icon would otherwise sit. The frame is the strong hairline, so a
 * light picture keeps an edge on a light ground and a dark one on a dark.
 */
export function PreviewArtThumbnail({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <Box
      border
      className="border-border-strong"
      height={22}
      overflow="hidden"
      rounded="xs"
      shrink={false}
      width={32}
    >
      {children}
    </Box>
  );
}
